import { DataTable, EmptyState, StatusBadge, type Spalte } from '../../muster';

/**
 * Die Höhenbänder des Arbeitsstands — je Geschoss/Bereich, mit dem
 * gerechneten Band zwischen Rohdecke und Abhangdecke/Unterzug.
 *
 * Ein unplausibler Befund steht als Fehlermarke: Ein Band, das gerechnet
 * wurde, aber nicht stimmen kann (z. B. negative Höhe), ist gefährlicher als
 * ein fehlendes — ein Vorschlag, der sich darauf beruft, sähe aus wie eine
 * Rechnung und wäre keine. Seit U6a trägt er Zeichen und Text, nicht nur Rot.
 */
export function Hoehenbaender({ hoehenbaender }: { hoehenbaender: any[] }) {
  const unplausibel = (h: any) => !!h.befund
    && h.befund !== 'plausibel'
    && String(h.befund).toLowerCase().includes('unplausibel');

  const spalten: Spalte<any>[] = [
    {
      schluessel: 'geschoss', titel: 'Geschoss', immerSichtbar: true, breite: '120px',
      wert: (h) => h.geschoss,
    },
    {
      schluessel: 'bereich', titel: 'Bereich', breite: '130px',
      wert: (h) => h.planungsbereich ?? '',
      inhalt: (h) => h.planungsbereich ?? '—',
    },
    {
      schluessel: 'rohdecke', titel: 'Rohdecke UK', art: 'zahl', einheit: 'mm',
      nachkomma: 0, wert: (h) => h.rohdeckeUkMm,
    },
    {
      schluessel: 'abhang', titel: 'Abhang OK', art: 'zahl', einheit: 'mm',
      nachkomma: 0, wert: (h) => h.abhangOkMm,
    },
    {
      schluessel: 'unterzug', titel: 'Unterzug UK', art: 'zahl', einheit: 'mm',
      nachkomma: 0, wert: (h) => h.unterzugUkMm,
    },
    {
      schluessel: 'band', titel: 'Band', art: 'zahl', einheit: 'mm',
      nachkomma: 0, wert: (h) => h.bandHoeheMm,
    },
    {
      schluessel: 'bauteile', titel: 'Bauteile', art: 'zahl', wert: (h) => h.bauteile,
    },
    {
      schluessel: 'befund', titel: 'Befund', art: 'status', breite: '190px',
      wert: (h) => h.befund ?? 'plausibel',
      inhalt: (h) => (
        <StatusBadge
          klein
          zustand={unplausibel(h) ? 'fehler' : 'gut'}
          text={h.befund ?? 'plausibel'}
        />
      ),
    },
  ];

  return (
    <DataTable
      name="Höhenbänder"
      spalten={spalten}
      zeilen={hoehenbaender ?? []}
      schluessel={(h) => `${h.geschoss}|${h.planungsbereich}`}
      ausfuhr
      leer={(
        <EmptyState
          titel="Keine Höhenbänder für diesen Stand."
          erklaerung={'Das Band entsteht aus Rohdecke, Abhangdecke und Unterzug — fehlt '
            + 'eines davon im Modell, lässt es sich nicht rechnen.'}
        />
      )}
    />
  );
}
